module.exports = __webpack_public_path__ + "img/Support-skill-214.b15a2c5c.png";